var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 29.9988C23.2843 29.9988 30 23.2831 30 14.9988C30 6.71451 23.2843 -0.0012207 15 -0.0012207C6.71573 -0.0012207 0 6.71451 0 14.9988C0 23.2831 6.71573 29.9988 15 29.9988Z",
    fill: "#FFDB5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3516 16.555C12.065 16.5578 11.8016 16.3702 11.7359 16.08L9.92414 8.24937C9.85152 7.91021 10.055 7.58217 10.3819 7.51127C10.7193 7.42641 11.0491 7.64209 11.12 7.96901L12.9317 15.7997C13.0043 16.1388 12.8009 16.4669 12.474 16.5378C12.4373 16.5429 12.3883 16.5498 12.3516 16.555Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1422 15.3076C16.8556 15.3105 16.5922 15.1229 16.5265 14.8327L14.6153 6.9162C14.5305 6.57876 14.7339 6.25072 15.0714 6.16586C15.4088 6.08101 15.7368 6.28445 15.8217 6.62189L17.7328 14.5384C17.8177 14.8758 17.6143 15.2039 17.2768 15.2887C17.2279 15.2956 17.1912 15.3008 17.1545 15.3059L17.1422 15.3076Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4764 23.9639C15.3907 23.976 15.3016 23.9635 15.202 23.965C10.2012 23.8943 7.34155 16.5977 7.22342 16.2899C7.10358 15.9698 7.26516 15.6102 7.57297 15.4921C7.89301 15.3723 8.2526 15.5339 8.37073 15.8417C8.39328 15.9134 11.0514 22.6643 15.2153 22.7279C16.4402 22.7429 17.3952 22.3467 18.124 21.4956C20.6065 18.6513 19.5979 11.9181 19.5875 11.8447C19.5394 11.5021 19.7707 11.195 20.0994 11.1364C20.442 11.0882 20.749 11.3196 20.8077 11.6482C20.8489 11.9419 21.9163 19.0037 19.0588 22.2876C18.1461 23.3392 16.9391 23.8956 15.4729 23.9394L15.4764 23.9639Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.b8200ef3b382a4fb0b9b98897839c278.svg";
export { ForwardRef as ReactComponent };